module.exports = __webpack_public_path__ + "static/media/dpl2.png.2e33060c.jpg";